
define(
	'Code25.CaterpartsGlobal.PartsBook.View'
	, [
		"Handlebars", "Utils", "Code25.partsbook.tpl", "Code25.CaterpartsGlobal.PartsBook.Model"
	]
	, function (
		Handlebars, Utils, Code25_partsbook_tpl, PartsBookModel
	) {
		'use strict';




		return Backbone.View.extend({

			template: Code25_partsbook_tpl,
			initialize: function (options) {
				this.custitem_c25_partsbook = options.custitem_c25_partsbook;
				this.custitem_c25_partsbookpdf = options.custitem_c25_partsbookpdf;
				
				this.state = "none";
				this.index = 0;
				var self = this;
				if(this.custitem_c25_partsbookpdf){

				}
				else if (this.custitem_c25_partsbook && this.custitem_c25_partsbook != "&nbsp;") {
					this.state = "loading";
					var item = this.options.item;
					console.log("load parts for item " + item);
					this.model = new PartsBookModel();
					this.model.fetch(
						{ data: { item: item } }
					).done(function (result) {
						// console.log(result);
						if (result.ok) {
							self.state = "loaded";
							self.render();
							//self.calcImageSizes();
						} else {
							self.state = "error";
							self.error = result.error;
							self.render();
						}
					}).catch(function (err) {
						console.error(err);

						self.state = "error";
						self.error = (err.message || err.responseText || err).toString();
						self.render();
					});
				}
			},
			events: {

				'click [data-action="prev"]': 'prevPage',
				'click [data-action="next"]': 'nextPage'

			},

			prevPage: function (e) {
				e.preventDefault();
				e.stopPropagation();
				var diagrams = this.model.get("diagrams") || [];
				if (diagrams.length > 1) {
					this.index--;
					if (this.index < 0) {
						this.index = diagrams.length - 1;
					}
					this.render();
				}
			},
			nextPage: function (e) {
				e.preventDefault();
				e.stopPropagation();
				var diagrams = this.model.get("diagrams") || [];
				if (diagrams.length > 1) {
					this.index++;
					if (this.index >= diagrams.length) {
						this.index = 0;
					}
					this.render();
				}
			}
			, getRefNumber: function (refnum, pos) {
				if (refnum) {
					var body = "", char, extra = 0;
					for (var i = 0; i < refnum.length; i++) {
						char = refnum.charAt(i);
						if ((char >= '0' && char <= '9') || char == '.') {
							body += char;
						} else {
							extra += refnum.charCodeAt(i) / 1000;
						}
					}
					if (body) {
						try {
							return parseFloat(body) + extra;
						} catch (err) { }
					}
				}
				return pos;

			}
			,

			getContext: function getContext() {

				var res = {
					index: this.index,
					page: this.index + 1,
					state: this.state,
					error: this.error,
					partsbook: this.model
				};
				if(this.custitem_c25_partsbookpdf){
res.pdf=this.custitem_c25_partsbookpdf;
				}
				else if (this.state == "loaded") {
					var diagrams = this.model.get("diagrams") || [];
					res.pages = diagrams.length;
					res.showPages = res.pages > 1;
					res.diagram = diagrams[this.index];
					if (res.diagram) {
						res.diagram.dotradius = res.diagram.dotradius || 22;
						if (res.diagram.dotradius <= 24) {
							res.diagram.dotclass = "dot-sm";
						} else if (res.diagram.dotradius <= 30) {
							res.diagram.dotclass = "dot-md";
						} else {
							res.diagram.dotclass = "dot-lg";
						}
						res.diagram.dotdiameter = res.diagram.dotradius * 2;
						res.diagram.texttop = (res.diagram.dotdiameter - 30) / 2;

						res.diagram.width = 800;
						res.diagram.height = 875;
						if (res.diagram.imagecontent) {
							var start = res.diagram.imagecontent.toLowerCase().indexOf("viewbox=");
							if (start > -1) {
								var end = res.diagram.imagecontent.toLowerCase().indexOf("\"", start + 9);
								var viewbox = res.diagram.imagecontent.substring(start + 9, end);
								if (viewbox) {
									var rect = viewbox.split(" ");
									res.diagram.width = parseInt(rect[2] || "800");
									res.diagram.height = parseInt(rect[3] || "875");
								}
							}
						}
						var self = this;

						res.diagram.items.sort(function (A, B) {
							return self.getRefNumber(A.ref, (parseInt(A.x) + (parseInt(A.y) * 5))) - self.getRefNumber(B.ref, (parseInt(B.x) + (parseInt(B.y) * 5)));
						});

						var pos = {}, newPos; //track repeat positions.
						for (var i = 0; i < res.diagram.items.length; i++) {


							res.diagram.items[i].number = res.diagram.items[i].ref || (i + 1).toString();
							res.diagram.items[i].extraLetter = "a";
							res.diagram.items[i].dotradius = res.diagram.dotradius;
							res.diagram.items[i].dotclass = res.diagram.dotclass;
							res.diagram.items[i].dotdiameter = res.diagram.dotdiameter;
							res.diagram.items[i].texttop = res.diagram.texttop;
							res.diagram.items[i].px = (100 * parseInt(res.diagram.items[i].x) / res.diagram.width).toFixed(4);
							res.diagram.items[i].py = (100 * parseInt(res.diagram.items[i].y) / res.diagram.height).toFixed(4);
							res.diagram.items[i].pwidth = (100 * parseInt(res.diagram.items[i].width) / res.diagram.width).toFixed(4);
							res.diagram.items[i].pheight = (100 * parseInt(res.diagram.items[i].height) / res.diagram.height).toFixed(4);
							if (res.diagram.items[i].pwidth > 0 && res.diagram.items[i].pheight > 0) {
								res.diagram.items[i].hasRect = true;
							}

							res.diagram.items[i].right = res.diagram.items[i].px > 50;
							res.diagram.items[i].extra = [];

							newPos = res.diagram.items[i].x + " " + res.diagram.items[i].y + " " + res.diagram.items[i].width + " " + res.diagram.items[i].height;
							if (pos[newPos]) {
								pos[newPos].hasExtra = true;
								pos[newPos].extra.push(res.diagram.items[i]);
								res.diagram.items[i].extraClass = "repeat" + pos[newPos].extra.length;
								res.diagram.items[i].extraLetter = String.fromCharCode(97 + pos[newPos].extra.length);
								res.diagram.items[i].hasExtra=true;
								res.diagram.items[i].show = false;
							} else {
								pos[newPos] = res.diagram.items[i];
								res.diagram.items[i].show = true;

							}
						}

						res.diagram.keys = [];
						var foundkey = {}, key;
						for (var i = 0; i < res.diagram.items.length; i++) {
							key = res.diagram.items[i].number + "-" + res.diagram.items[i].url;
							if (!foundkey[key]) {
								foundkey[key] = true;
								res.diagram.keys.push(res.diagram.items[i]);
							}
						}
					}
				}
				// console.log(res);
				return res;
			}
		});

	});
